<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box">
          <div class="box-header" v-if="exibirGrafico">
            <va-chart
                :chart-config='producaoGrafico'></va-chart>
          </div>
        </div>
      </div>
      <!-- /.box-header -->
    </div>
    <div class="row center-block">
      <div class="col-md-12" >
        <div class="box box-info">
          <div class="box-header col-md-12">
            <h3 v-if="flag === 'br'">Requisitos de pesquisa</h3>
            <h3 v-else-if="flag === 'de'">Suchanforderungen</h3>
            <h3 v-else-if="flag === 'us'">Search Requirements</h3>
            <h3 v-else>Requerimientos de búsqueda</h3>
            </br>
            <h4 v-if="flag === 'br'">Período</h4>
            <h4 v-else-if="flag === 'de'">Zeitraum</h4>
            <h4 v-else-if="flag === 'us'">Period</h4>
            <h4 v-else>Periodo</h4>
            <div class="form-group col-sm-12">
              <label for="dataInicioBusca" class="col-sm-2 control-label" v-if="flag === 'br'">Data Inicial</label>
              <label for="dataInicioBusca" class="col-sm-2 control-label" v-else-if="flag === 'de'">Startdatum</label>
              <label for="dataInicioBusca" class="col-sm-2 control-label" v-else-if="flag === 'us'">Initial date</label>
              <label for="dataInicioBusca" class="col-sm-2 control-label" v-else>Fecha de inicio</label>
              <div class="col-sm-4"> 
                <datepicker placeholder="Selecione a data inicial" v-model="dataInicioBusca" id="dataInicioBusca" v-if="flag === 'br'" :language="ptBR"></datepicker>
                <datepicker placeholder="Startdatum auswählen" v-model="dataInicioBusca" id="dataInicioBusca" v-else-if="flag === 'de'" :language="de"></datepicker>
                <datepicker placeholder="Select start date" v-model="dataInicioBusca" id="dataInicioBusca" v-else-if="flag === 'us'" :language="en"></datepicker>
                <datepicker placeholder="Seleccionar fecha de inicio" v-model="dataInicioBusca" id="dataInicioBusca" v-else :language="es"></datepicker>
              </div>
              <label for="dataFimBusca" class="col-sm-2 control-label" v-if="flag === 'br'">Data Final</label>
              <label for="dataFimBusca" class="col-sm-2 control-label" v-else-if="flag === 'de'">Enddatum</label>
              <label for="dataFimBusca" class="col-sm-2 control-label" v-else-if="flag === 'us'">Final date</label>
              <label for="dataFimBusca" class="col-sm-2 control-label" v-else>Fecha final</label>
             <div class="col-sm-4">
                <datepicker placeholder="Selecione a data final" v-model="dataFimBusca" id="dataFimBusca" v-if="flag === 'br'" :language="ptBR"></datepicker>
                <datepicker placeholder="Wählen Sie das Enddatum" v-model="dataFimBusca" id="dataFimBusca" v-else-if="flag === 'de'" :language="de"></datepicker>
                <datepicker placeholder="Select end date" v-model="dataFimBusca" id="dataFimBusca" v-else-if="flag === 'us'" :language="en"></datepicker>
                <datepicker placeholder="Seleccionar fecha de finalización" v-model="dataFimBusca" id="dataFimBusca" v-else :language="es"></datepicker>
              </div>
            </div>
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <div class="input-group">
              <h4 v-if="flag === 'br'">Parâmetro</h4>
              <h4 v-else-if="flag === 'de'">Parameter</h4>
              <h4 v-else-if="flag === 'us'">Parameter</h4>
              <h4 v-else>Parámetro</h4>
              <div class="form-group" v-if="flag === 'br'">
                <select class="form-control" id="parametro" v-model="parametro">
                  <option value="">Selecione o parâmetro</option>
                  <option :value="registro" v-for="(registro, propriedade, index) in orderBy(filterBy(filterBy(registros, false, 'is_acumulador'), true, 'registrado'), 'labelPtBr')" :key="index">{{registro.$value.labelPtBr}}</option>
                </select>
              </div>
              <div class="form-group" v-else-if="flag === 'de'">
                <select class="form-control" id="parametro" v-model="parametro">
                  <option value="">Parameter auswählen</option>
                  <option :value="registro" v-for="(registro, propriedade, index) in orderBy(filterBy(filterBy(registros, false, 'is_acumulador'), true, 'registrado'),'labelDe')" :key="key">{{registro.$value.labelDe}}</option>
                </select>
              </div>
              <div class="form-group" v-else-if="flag === 'us'">
                <select class="form-control" id="parametro" v-model="parametro">
                  <option value="">Select Parameter</option>
                  <option :value="registro" v-for="(registro, propriedade, index) in orderBy(filterBy(filterBy(registros, false, 'is_acumulador'), true, 'registrado'), 'labelEn')" :key="key">{{registro.$value.labelEn}}</option>
                </select>
              </div>
              <div class="form-group" v-else>
                <select class="form-control" id="parametro" v-model="parametro">
                  <option value="">Seleccionar parámetro</option>
                  <option :value="registro" v-for="(registro, propriedade, index) in orderBy(filterBy(filterBy(registros, false, 'is_acumulador'), true, 'registrado'), 'labelEs')" :key="key">{{registro.$value.labelEs}}</option>
                </select>
              </div>
              <br />
            </div>
          </div>
          <div class="box-footer">
            <div class="col-sm-2" v>
              <button type="button" v-on:click="efetuarPesquisa(flag)" class="btn btn-primary">
                <span v-if="flag === 'br'">Efetuar Pesquisa</span >
                <span v-else-if="flag === 'de'">Suche</span >
                <span v-else-if="flag === 'us'">Search</span >
                <span v-else>Buscar</span >
              </button>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
      </div>
    </div>  
  </section>
</template>

<script>
// import VueTimepicker from 'vue2-timepicker'
import Datepicker from 'vuejs-datepicker'
import {en, es, de, ptBR} from 'vuejs-datepicker/dist/locale'
import VAChart from '../VAChart'
import {firebaseApp} from '../../helpers/firebaseApp'
import Vue2Filters from 'vue2-filters'

var db = firebaseApp.database()
var sd202019Ref = db.ref('sd202019')

export default {
  name: 'Graficos',
  mixins: [Vue2Filters.mixin],
  components: {
    Datepicker,
    'va-chart': VAChart
  },
  firebase: {
    registros: sd202019Ref
  },
  mounted () {
  },
  computed: {
    producaoGrafico () {
      return this.$store.state.Relatorios.historico
    },
    flag () {
      return this.$store.state.flag
    },
    isMobile () {
      return (window.innerWidth <= 800 && window.innerHeight <= 600)
    }
  },
  data () {
    return {
      ptBR: ptBR,
      en: en,
      es: es,
      de: de,
      registros: {},
      showDismissibleAlert: false,
      messageAlert: '',
      dataInicioBusca: '',
      dataFimBusca: '',
      parametro: '',
      pesquisa: {
        dataInicioBusca: '',
        dataFimBusca: '',
        parametro: '',
        label: ''
      },
      exibirGrafico: false,
      errors: []
    }
  },
  methods: {
    debug (parametro, label) {
      console.log('Debug parametro: ' + parametro)
      console.log('Debug label: ' + label)
    },
    showAlert (titulo, mensagem, tipoMensagem, exibeBotao, textoBotao) {
      // Use sweetalret2
      this.$swal({
        title: titulo,
        text: mensagem,
        icon: tipoMensagem,
        showConfirmButton: exibeBotao,
        confirmButtonText: textoBotao
      })
    },
    efetuarPesquisa: function (bandeira) {
      var DadosInvalidos = 'DadosInvalidos'
      var DataVazia = 'DataVazia'
      var DataFinalAnterior = 'DataFinalAnterior'
      var SelecionarParametro = 'SelecionarParametro'
      var EnviandoDados = 'EnviandoDados'
      var AguardeGerar = 'AguardeGerar'
      var TituloGrafico = 'TituloGrafico'
      switch (bandeira) {
        case 'br':
          DadosInvalidos = 'Dados inválidos!'
          DataVazia = 'Não pode ter data vazia!'
          DataFinalAnterior = 'Data final não pode ser anterior à data inicial!'
          SelecionarParametro = 'Favor selecionar um parâmetro de pesquisa!'
          EnviandoDados = 'Enviando dados!'
          AguardeGerar = 'Aguarde enquanto o gráfico está sendo gerado!'
          break
        case 'de':
          DadosInvalidos = 'Ungültige Daten!'
          DataVazia = 'Kann kein leeres Datum haben!'
          DataFinalAnterior = 'Das Enddatum darf nicht vor dem Startdatum liegen!'
          SelecionarParametro = 'Bitte wählen Sie einen Suchparameter!'
          EnviandoDados = 'Daten senden!'
          AguardeGerar = 'Warten Sie, während das Diagramm generiert wird!'
          break
        case 'us':
          DadosInvalidos = 'Invalid data!'
          DataVazia = 'Cannot have empty date!'
          DataFinalAnterior = 'End date cannot be earlier than start date!'
          SelecionarParametro = 'Please select a search parameter!'
          EnviandoDados = 'Sending data!'
          AguardeGerar = 'Wait while the chart is being generated!'
          break
        default:
          DadosInvalidos = 'Datos inválidos!'
          DataVazia = '¡No se puede tener una fecha vacía!'
          DataFinalAnterior = '¡La fecha de finalización no puede ser anterior a la fecha de inicio!'
          SelecionarParametro = 'Por favor, seleccione un parámetro de búsqueda!'
          EnviandoDados = 'Enviando datos!'
          AguardeGerar = '¡Espere mientras se genera el gráfico!'
          break
      }
      this.exibirGrafico = false
      if ((this.dataInicioBusca === '') || (this.dataFimBusca === '')) {
        this.showAlert(DadosInvalidos, DataVazia, 'warning', true, 'Ok')
      } else if (this.dataInicioBusca > this.dataFimBusca) {
        this.showAlert(DadosInvalidos, DataFinalAnterior, 'warning', true, 'Ok')
      } else if (this.parametro === '') {
        this.showAlert(DadosInvalidos, SelecionarParametro, 'warning', true, 'Ok')
      } else {
        this.showAlert(EnviandoDados, AguardeGerar, 'info', false, 'Ok')
        this.showDismissibleAlert = false
        this.pesquisa.dataInicioBusca = this.dataInicioBusca.toISOString().substring(0, 10)
        this.pesquisa.dataFimBusca = this.dataFimBusca.toISOString().substring(0, 10)
        this.pesquisa.parametro = this.parametro.$key
        switch (bandeira) {
          case 'br':
            TituloGrafico = this.parametro.$value.labelPtBr
            break
          case 'de':
            TituloGrafico = this.parametro.$value.labelDe
            break
          case 'us':
            TituloGrafico = this.parametro.$value.labelEn
            break
          default:
            TituloGrafico = this.parametro.$value.labelEs
            break
        }
        this.pesquisa.label = TituloGrafico + ' (' + this.parametro.$value.unidade_medida + ') '
        this.$store.dispatch('createRelatorioHistorico', this.pesquisa)
        .then(response => {
          this.$swal.close()
          this.exibirGrafico = true
        })
        .catch(e => {
          this.errors.push(e)
        })
      }
    }
  }
}
</script>

<style>
.datetime-picker input {
  height: 4em !important;
}
</style>



// WEBPACK FOOTER //
// Graficos.vue?1307dabe